import { colors } from "@/styles/styleVariables";
import { breakpoints } from "@/utils/breakPoints";

import { css } from "@emotion/react";

export const twoColumnsBreakpoint = breakpoints.tablet1024;
export const oneColumnBreakpoint = breakpoints.tablet768;
export const gridGapInRem = 3;

export const wrapper = css`
  
`;

export const pageTitle = css`
  color: ${colors.slate["900"]};
  font-size: clamp(3rem, 7.5vw, 7.2rem);
  margin: 1em 0;
`;

export const categoriesSelectWrapper = css`
  display: flex;
  align-items: center;
  margin-bottom: 8rem;
`;

export const articlesGrid = css` 
  display: grid;
  gap: ${gridGapInRem}rem;
  margin-bottom: 20rem;
  grid-template-columns: repeat(3, 1fr);
  @media screen and (max-width: ${twoColumnsBreakpoint}px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: ${oneColumnBreakpoint}px) {
    grid-template-columns: 1fr;
  }
`;
